import Body from "../components/Body";
import BucketManager from "../components/budget/BucketManager";

export default function BucketManagementPage() {
  return (
    <Body sidebar>
      <BucketManager />
    </Body>
  );
}
